import { Card, CardContent, Typography, Accordion, AccordionSummary, AccordionDetails, Box, Chip, Paper, Alert } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { ResultCardProps } from "./types";

export default function ResultCard({ title, results, resultType, expandedResults, onToggle }: ResultCardProps) {
  return (
    <Card sx={{ mt: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        {results?.results?.map((result, index) => {
          const isExpanded = expandedResults[`${resultType}-${index}`];
          return (
            <Accordion key={index} sx={{ mb: 1 }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                onClick={() => onToggle(resultType, index)}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
                  {result.success ? <CheckCircleIcon color="success" /> : <ErrorIcon color="error" />}
                  <Typography variant="subtitle1">
                    {result.appServiceName} → {result.subdomain}
                  </Typography>
                  <Chip
                    label={result.success ? "Success" : "Failed"}
                    color={result.success ? "success" : "error"}
                    size="small"
                    sx={{ ml: "auto" }}
                  />
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {result.message}
                </Typography>

                {result.details && (
                  <Paper sx={{ p: 2, bgcolor: "grey.50", mb: 2 }}>
                    <Typography variant="caption" display="block" gutterBottom>
                      Details:
                    </Typography>
                    {Object.entries(result.details).map(([key, value]) => (
                      <Typography key={key} variant="body2" sx={{ fontFamily: "monospace", mb: 0.5 }}>
                        <strong>{key}:</strong> {value}
                      </Typography>
                    ))}
                  </Paper>
                )}

                {result.error && (
                  <Alert severity="error" sx={{ mt: 1 }}>
                    {result.error}
                  </Alert>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </CardContent>
    </Card>
  );
}
